import { useEffect, useState } from 'react';
import { useBuildex } from '../use-buildex/index';
import { useHealthdex } from '../use-healthdex/index';
import { useTradex } from '../use-tradex/index';

const useTheme = () => {
	const isBuildex = useBuildex();
	const isTradex = useTradex();
	const isHealthdex = useHealthdex();
	const [isThemeSet, setIsThemeSet] = useState(false);

	useEffect(() => {
		const loadTheme = async () => {
			if (isTradex) {
				await import('@/assets/scss/theme/tradex.scss');
			} else if (isBuildex) {
				await import('@/assets/scss/theme/buildex.scss');
			} else if (isHealthdex) {
				await import('@/assets/scss/theme/healthdex.scss');
			} else {
				await import('@/assets/scss/theme/default.scss');
			}
		};
		if(!isThemeSet) {
			setIsThemeSet(true);
			// Reveal the app (hidden by critical CSS in index.html) once the
			// themed stylesheet has loaded — avoids flash-of-unstyled-content on
			// full-page navigations. `.finally` so a failed load still reveals.
			loadTheme().finally(() => {
				document.documentElement.classList.add('theme-ready');
			});
		}
	}, [isThemeSet]);
};

export default useTheme;
